export default __webpack_public_path__ + "3093856ed6581bb029b84771a6a23ca1.svg";